export default "__VITE_ASSET__BIX0Ss2W__"